/* Größenberater (Stanley/Stella Creator 2.0).
   Öffnen läuft über Event-Delegation auf document, damit auch per innerHTML
   injizierte Kopien (Quick-Add-Modal) funktionieren. Die Logik im Dialog wird
   beim ersten Öffnen direkt an den Dialog gebunden, und ALLE Events werden am
   Dialog-Rand gestoppt: die Theme-Komponenten (variant-picker, product-form)
   reagieren sonst auf bubbelnde input/change-Events und setzen Eingaben zurück. */
(function () {
  if (window.__vhSizeGuide) return;
  window.__vhSizeGuide = true;

  // Halbe Brustweite / Körperlänge in cm laut offiziellem STTU169-Datenblatt
  var SIZES = [
    { n: 'XS', c: 47.5, l: 65 },
    { n: 'S', c: 49.5, l: 69 },
    { n: 'M', c: 53.5, l: 73 },
    { n: 'L', c: 56.5, l: 75 },
    { n: 'XL', c: 59.5, l: 77 },
    { n: 'XXL', c: 63.5, l: 79 }
  ];
  // Ziel-Mehrweite (cm Umfang) je Passform. Kalibriert auf zwei Anker:
  // 180 cm / 74 kg körpernah = S, 190 cm / 95 kg körpernah = L.
  var EASE = { slim: 2.5, regular: 8, loose: 14 };
  var FIT_LABEL = { slim: 'körpernah', regular: 'Standard', loose: 'locker' };

  function recommend(h, w, fit) {
    // Brustumfang-Schätzung nach ANSUR-II-Regression (ziviles Niveau):
    // negativer Größen-Koeffizient, bei gleichem Gewicht sind Größere schlanker.
    var chest = 0.63 * w - 0.28 * h + 99.5;
    var minLen = 0.375 * h; // Mindest-Shirtlänge, sonst wirkt es zu kurz
    // Ease-Ziel skaliert mit der Körpergröße (+0,2 cm pro cm über/unter 175):
    // Kleine brauchen weniger Luft (158/59 standard = S), Große mehr
    // (190/95 standard = XL). Recherche-validiert an 7 Marktpunkten.
    var hClamped = Math.min(200, Math.max(160, h));
    var target = (EASE[fit] || EASE.slim) + 0.2 * (hClamped - 175);
    // Gewählt wird die Größe, deren Mehrweite dem Ziel am nächsten kommt.
    // Zu wenig Luft wiegt dreifach (lieber etwas weiter als zu eng),
    // negative Mehrweite (enger als der Körper) ist ausgeschlossen.
    var score = function (ease) {
      return ease < target ? 3 * (target - ease) : ease - target;
    };
    var bestChest = -1;   // Sieger rein nach Brustmaß
    var best = -1;        // Sieger inkl. Mindestlänge
    for (var i = 0; i < SIZES.length; i++) {
      var ease = 2 * SIZES[i].c - chest;
      if (ease < 0) continue;
      if (bestChest < 0 || score(ease) < score(2 * SIZES[bestChest].c - chest)) bestChest = i;
      if (SIZES[i].l >= minLen) {
        if (best < 0 || score(ease) < score(2 * SIZES[best].c - chest)) best = i;
      }
    }
    if (best < 0) {
      return { size: SIZES[SIZES.length - 1].n, capped: true, lengthDriven: false };
    }
    return { size: SIZES[best].n, capped: false, lengthDriven: bestChest > -1 && best > bestChest };
  }

  function activeFit(dlg) {
    var btn = dlg.querySelector('[data-vh-sg-fit].is-active');
    return btn ? btn.getAttribute('data-vh-sg-fit') : 'slim';
  }

  function update(dlg) {
    var out = dlg.querySelector('[data-vh-sg-result]');
    if (!out) return;
    var h = parseFloat((dlg.querySelector('[data-vh-sg-height]') || {}).value);
    var w = parseFloat((dlg.querySelector('[data-vh-sg-weight]') || {}).value);
    if (!h || !w) {
      out.innerHTML = '<p class="vh-sizeguide__hint">Gib deine Körpergröße und dein Gewicht ein.</p>';
      return;
    }
    if (h < 140 || h > 210 || w < 40 || w > 150) {
      out.innerHTML = '<p class="vh-sizeguide__hint">Bitte prüfe deine Angaben (140 bis 210 cm, 40 bis 150 kg).</p>';
      return;
    }
    var fit = activeFit(dlg);
    var r = recommend(h, w, fit);
    var note = r.capped
      ? 'Das ist unsere größte Größe. Bei dir fällt sie eher körpernah aus.'
      : 'Bei ' + Math.round(h) + ' cm und ' + Math.round(w) + ' kg, Passform ' + FIT_LABEL[fit] + '.';
    if (r.lengthDriven) {
      note += ' Diese Größe brauchst du für die Länge, an der Brust sitzt sie etwas lockerer.';
    }
    // Nur einen Übernehmen-Button anbieten, wenn die Größe im Produkt wählbar ist
    var applyable = findSizeOption(dlg, r.size);
    var apply = applyable
      ? '<button type="button" class="vh-sizeguide__apply" data-vh-sg-apply="' + r.size + '">Größe ' + r.size + ' übernehmen</button>'
      : '';
    out.innerHTML =
      '<p class="vh-sizeguide__reco">Unsere Empfehlung: <strong>' + r.size + '</strong></p>' +
      '<p class="vh-sizeguide__why">' + note + '</p>' +
      apply;
  }

  // Produkt-Kontext (Produktseite oder Quick-Add-Modal), in dem der Berater steckt
  function productScope(dlg) {
    var wrap = dlg.closest('.vh-sizeguide');
    if (!wrap) return document;
    return wrap.closest('.quick-add-modal') || wrap.closest('.product-details') || document;
  }

  // Das <select> und die <option>, die zu einer Größe gehören (nur das Size-Dropdown hat XS/S/M...)
  function findSizeOption(dlg, size) {
    var scope = productScope(dlg);
    var selects = scope.querySelectorAll('.variant-option__select');
    for (var i = 0; i < selects.length; i++) {
      for (var j = 0; j < selects[i].options.length; j++) {
        if (selects[i].options[j].value === size) {
          return { select: selects[i], option: selects[i].options[j] };
        }
      }
    }
    return null;
  }

  function applySize(dlg, size) {
    var found = findSizeOption(dlg, size);
    if (!found) return;
    found.select.value = size;
    found.select.dispatchEvent(new Event('change', { bubbles: true }));
    dlg.close();
  }

  function bind(dlg) {
    if (dlg.__vhBound) return;
    dlg.__vhBound = true;

    dlg.addEventListener('click', function (e) {
      var fitBtn = e.target.closest('[data-vh-sg-fit]');
      if (fitBtn) {
        dlg.querySelectorAll('[data-vh-sg-fit]').forEach(function (b) {
          var on = b === fitBtn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        update(dlg);
      } else if (e.target.closest('[data-vh-sg-apply]')) {
        applySize(dlg, e.target.closest('[data-vh-sg-apply]').getAttribute('data-vh-sg-apply'));
      } else if (e.target.closest('[data-vh-sizeguide-close]')) {
        dlg.close();
      } else if (e.target.closest('[data-vh-sg-tabletoggle]')) {
        var toggle = e.target.closest('[data-vh-sg-tabletoggle]');
        var table = dlg.querySelector('[data-vh-sg-table]');
        var show = table.hasAttribute('hidden');
        if (show) table.removeAttribute('hidden');
        else table.setAttribute('hidden', '');
        toggle.setAttribute('aria-expanded', show ? 'true' : 'false');
        toggle.textContent = show ? 'Größentabelle ausblenden' : 'Größentabelle anzeigen';
      } else if (e.target === dlg) {
        // Klick auf den Backdrop schließt
        dlg.close();
      }
      e.stopPropagation();
    });

    dlg.addEventListener('input', function (e) {
      if (e.target.matches('[data-vh-sg-height], [data-vh-sg-weight]')) update(dlg);
      e.stopPropagation();
    });

    // Nichts davon darf die Theme-Komponenten außerhalb erreichen
    ['change', 'keydown', 'keyup', 'keypress', 'pointerdown', 'pointerup', 'focusin', 'focusout', 'submit'].forEach(function (t) {
      dlg.addEventListener(t, function (e) { e.stopPropagation(); });
    });
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-vh-sizeguide-open]');
    if (!openBtn) return;
    e.preventDefault();
    e.stopPropagation();
    var wrap = openBtn.closest('.vh-sizeguide');
    var dlg = wrap && wrap.querySelector('[data-vh-sizeguide-dialog]');
    if (dlg) {
      bind(dlg);
      if (!dlg.open) dlg.showModal();
      update(dlg);
    }
  });
})();
